/**
 * Utility functions for chart formatting and calculations
 */

/**
 * Format large numbers with K/M suffixes
 */
export const formatLargeNumber = (num: number): string => {
  if (num >= 1000000) return (num / 1000000).toFixed(2) + ' M';
  if (num >= 10000) return (num / 1000).toFixed(2) + ' k';
  if (num >= 1000) return (num / 1000).toFixed(2) + ' k';
  return num.toString();
};

/**
 * Normalize a value to SVG coordinate space
 */
export const normalizeValue = (
  value: number,
  minVal: number,
  maxVal: number,
  height: number,
  topPadding: number,
  bottomPadding: number
): number => {
  if (maxVal === minVal) return height / 2;
  return (height - bottomPadding) - ((value - minVal) / (maxVal - minVal)) * (height - topPadding - bottomPadding);
};

/**
 * Generate points string for SVG polyline
 */
export const generatePolylinePoints = (
  dataPoints: number[],
  width: number,
  normalizeY: (val: number) => number
): string => {
  if (dataPoints.length < 2) {
    return `0,${normalizeY(dataPoints[0] || 0)} ${width},${normalizeY(dataPoints[0] || 0)}`;
  }
  
  const pointSpan = Math.max(1, dataPoints.length - 1);
  return dataPoints.map((val, index) => {
    const x = (index / pointSpan) * width;
    const y = normalizeY(val);
    return `${x},${y}`;
  }).join(' ');
};

/**
 * Calculate tooltip transform based on position to avoid edge overflow
 */
export const getTooltipTransform = (
  index: number,
  totalPoints: number,
  offset: string = 'calc(-100% - 14px)'
): string => {
  if (index < 2) {
    return `translate(0%, ${offset})`;
  }
  if (index > totalPoints - 3) {
    return `translate(-100%, ${offset})`;
  }
  return `translate(-50%, ${offset})`;
};
